module.exports = __webpack_public_path__ + "static/media/hab2-0.0fd22702.jpg";